<div [hidden]="!ViewReady" fxLayout="column" fxLayoutAlign="start start">
	<h2 class="mat-display-1">
		Select Designees -
		<span *ngIf="CurrentSchool">{{CurrentSchool.SchoolName}} <span *ngIf="CurrentSchool.InSchoolGroup">({{CurrentSchool?.SchoolNumberList}})</span><span *ngIf="!CurrentSchool.InSchoolGroup">({{CurrentSchool?.SchoolNumber}})</span></span>
		<span *ngIf="!CurrentSchool">None Selected</span>
	</h2>
    <div *ngIf="!CurrentSchool">
        No current school has been selected at this time. Please use the "Choose School" button to the left to select an active school
        before attempting to select designees for a school.
    </div>
    <div *ngIf="CurrentSchool">
        <div>
            Listed below are all defined {{ AwardInfo?.BannerName }} designees for this location.
			Designees are individuals which are granted the ability to use this site that would normally not have these rights.
			<strong>Principals, Assistant Principals, and Nominees are roles which already have predefined rights and should not be made designees under normal circumstances.</strong>
			You may specify which rights the designees have, including make nominations and complete nomination forms.
        </div>
        <div
            class="buttongroup"
            fxLayout="row"
            fxLayoutAlign="start start"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start center"
            *ngIf="ShowingWindowPanel !== true"
        >
            <button mat-raised-button color="primary" (click)="ShowDesigneePanel()" [disabled]="ShowingDesigneePanel">
                Add New Designee
            </button>
        </div>
    </div>
    <div *ngIf="ShowingDesigneePanel" class="mat-elevation-z12 entrypanel" style="margin-bottom:20px">
        <form [formGroup]="DesigneeEntryForm" novalidate fxLayout="column">
            <h2 class="primarycolor500">
                <span>{{ DesigneeEntryForm.get('DesigneeID')?.value != null ? 'Edit' : 'New' }} Designee Form</span>
                <span *ngIf="DesigneeEntryForm.get('DesigneeID')?.value != null">
                    - {{ DesigneeEntryForm.get('FirstName')?.value }} {{ DesigneeEntryForm.get('LastName')?.value }}</span
                >
            </h2>
            <div fxLayout="column" fxLayoutAlign="start start">
                <div *ngIf="DesigneeEntryForm.get('DesigneeID')?.value == null"
                     fxLayout="row"
                     fxLayoutAlign="start center"
                     fxLayoutGap="25px">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                        <app-form-label [required]="true">User: </app-form-label>
                        <span *ngIf="DesigneeEntryForm?.get('SAPID')?.value">
                            {{ DesigneeEntryForm?.get('LastName')?.value | titleCase }},
                            {{ DesigneeEntryForm?.get('FirstName')?.value | titleCase }} (SAPID
                            {{ DesigneeEntryForm?.get('SAPID')?.value }})
                        </span>
                        <button type="button" mat-raised-button color="primary" (click)="ShowPersonLookup()">Find User</button>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <app-form-label>Expiration Date:</app-form-label>
                    <mat-form-field appearance="outline">
                        <input type="text"
                               matInput
                               formControlName="ExpirationDate"
                               [matDatepicker]="expirationpicker"
                               [max]="maxDate"
                               placeholder="Enter expiration date..." />
                        <mat-datepicker-toggle matSuffix [for]="expirationpicker"></mat-datepicker-toggle>
                        <mat-datepicker #expirationpicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px" formArrayName="Rights">
                    <ng-container *ngFor="let right of DesigneeEntryForm?.get('Rights')?.controls" [formGroup]="right">
                        <mat-checkbox formControlName="Value">{{ right?.get('Description')?.value }}</mat-checkbox>
                    </ng-container>
                </div>
            </div>
            <div class="margin-top">
                <em>Note: If no expiration date is given, the date will be set to nine months from now.</em>
            </div>
        </form>
        <div class="actionbuttons" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
            <button type="button" mat-raised-button color="primary" (click)="AddDesignee()" [disabled]="!DesigneeEntryForm.valid">
                <span>{{ DesigneeEntryForm?.get('DesigneeID')?.value != null ? 'Update' : 'Add' }}</span>
            </button>
            <button type="button" mat-raised-button color="warn" (click)="CancelDesigneePanel()">Cancel</button>
        </div>
    </div>

    <!-- Designees Table -->
    <div *ngIf="CurrentSchool && Designees?.length > 0">
        <table mat-table #table [dataSource]="DesigneesData" matSort matSortActive="LastName" matSortDirection="asc">
            <ng-container matColumnDef="LastName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Last Name</th>
                <td mat-cell *matCellDef="let des" class="centered">
                    <span>{{ des.LastName | titleCase }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="FirstName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">First Name</th>
                <td mat-cell *matCellDef="let des" class="centered">
                    <span>{{ des.FirstName | titleCase }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="SAPID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">SAPID</th>
                <td mat-cell *matCellDef="let des" class="centered">
                    <span>{{ des.SAPID }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="Title">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Title</th>
                <td mat-cell *matCellDef="let des" class="centered">
                    <span>{{ des.Title }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="ExpirationDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Expiration Date</th>
                <td mat-cell *matCellDef="let des" class="centered">
                    <div>{{ des.ExpirationDate | datefns: 'M/d/yyyy' }}</div>
                </td>
            </ng-container>

            <ng-container matColumnDef="DesigneeActive">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Active</th>
                <td mat-cell *matCellDef="let des" class="centered">
                    <span>{{ des.DesigneeActive | yesNo }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="Rights">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Rights</th>
                <td mat-cell *matCellDef="let des" class="centered">
                    <ul *ngIf="des.Rights">
                        <li *ngFor="let right of des.Rights">{{ right.Description }}</li>
                    </ul>
                </td>
            </ng-container>

            <ng-container matColumnDef="Actions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Action(s)</th>
                <td mat-cell *matCellDef="let des" class="centered">
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" fxLayoutWrap>
                        <button mat-raised-button color="primary" (click)="ShowDesigneePanel(des)" class="buttonpad">Edit</button>
                        <button mat-raised-button color="warn" (click)="RemoveDesignee(des)">Remove</button>
                    </div>
                </td>
            </ng-container>

            <!-- <ng-container matColumnDef="SmallDisplay">
            <mat-header-cell *matHeaderCellDef class="centered">Term(s)</th>
            <td *matCellDef="let term">
                <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>College Year</div>
                        <div>{{term.CollegeSchoolYear | collegeSchoolYear:AdminCollege.CollegeID}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Term Code</div>
                        <div>{{term.TermCode}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Term</div>
                        <div>{{term.TermCode | collegeTerm}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Beginning Date</div>
                        <div>{{term.DateBegin | datefns:'M/dd/yyyy'}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Ending Date</div>
                        <div>{{term.DateEnd | datefns:'M/dd/yyyy'}}</div>
                    </div>
                    <div class="smalldisplaybuttongroup" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <button mat-raised-button color="primary" (click)="ShowTermEntryEditorPanel(term)">Edit Term Window</button>
                        <button mat-raised-button color="warn" (click)="RemoveTerm(term)" [disabled]="term.InUse === true">Remove Term Window</button>
                    </div>
                </div>
            </td>
        </ng-container> -->

            <ng-container matColumnDef="NoData">
                <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
                <td *matCellDef="let des" [attr.colspan]="AllHeaders?.length">
                    <em>No designees have been set for this location.</em>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="AllHeaders"></tr>
            <tr mat-row *matRowDef="let row; columns: AllHeaders; let $even = even" [class.primarybackground50]="$even"></tr>
        </table>

        <mat-paginator
            #paginator
            [length]="DesigneesData?.data?.length"
            [pageIndex]="0"
            [pageSize]="SmallDisplay ? 5 : 10"
            [pageSizeOptions]="[5, 10, 25, 100]"
        ></mat-paginator>
    </div>
</div>
